module.exports = " <div class=help _v-194fca2e=\"\"> <hd title=法律条款和隐私政策 _v-194fca2e=\"\"></hd> <ul _v-194fca2e=\"\"> <li v-touch:tap=jump(1) _v-194fca2e=\"\">响车车平台协议</li> <li v-touch:tap=jump(2) _v-194fca2e=\"\">车辆租赁合同</li> <li v-touch:tap=jump(3) _v-194fca2e=\"\">隐私政策</li> <li v-touch:tap=jump(4) _v-194fca2e=\"\">证照信息</li> </ul> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-194fca2e&file=law.vue!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/static_page/law.vue
// module id = 636
// module chunks = 13